export default __webpack_public_path__ + "static/font-ab7bfae89b115c71fc027829354d2756.woff2";